import { StyleSheet } from 'aphrodite';
import { hexToRGBA } from '../../../../models/UiUtils';
import { THEME } from '../../../components-v2/Theme/theme';
import {
	aceGray,
	background,
	brandPrimary,
	brandPrimaryHover,
	charmGray,
	destructive,
	magicOrange,
	prestoPurple,
	spanishBlue,
	success,
	titles,
	white,
} from '../../../styles/colors';
import { CssSelectors } from '../../../styles/styles';

const backgroundKeyframes = {
	'0%': {
		backgroundPosition: '0% 50%',
	},
	'50%': {
		backgroundPosition: '100% 50%',
	},
	'100%': {
		backgroundPosition: '0% 50%',
	},
};

export const styleSheet = StyleSheet.create({
	button: {
		width: '100%',
		marginBottom: 8,
	},

	buttonSmall: {
		marginBottom: 4,
	},
	calendarCardApprove: {
		background: white,
		fontSize: 12,
		borderRadius: 4,
		margin: 0,
		padding: 0,
		color: brandPrimary,
		textShadow: 'none',
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'flex-start',
	},
	calendarCardApproveQuarterly: {
		fontSize: 12,
		display: 'inline-flex',
		gap: 4,
	},
	calendarCardApproveForwardIcon: {
		height: 'auto',
		transform: 'rotate3d(0,0,1,-90deg)',
		width: 11,
	},
	cardLabel: {
		position: 'absolute',
		top: -1,
		left: -1,
		borderRadius: '8px 0 8px 0',
		fontSize: 10,
		padding: '4px 12px',
		color: white,
	},
	cardLabelMonthly: {
		position: 'absolute',
		top: -1,
		left: -1,
		borderRadius: '8px 8px 0px 0',
		fontSize: 10,
		padding: '4px 12px',
		color: white,
		width: 'calc(100% + 2px)',
		boxSizing: 'border-box',
	},
	cardLabelQuarterlyFeatured: {
		textAlign: 'left',
	},
	featuredHeader: {
		background: 'linear-gradient(270deg, #32C5FF 10%, #B620E0 100%)',
		animationDuration: '30s',
		animationIterationCount: 'infinite',
		animationFillMode: 'linear',
		backgroundSize: '200% 200%',
		animationName: [backgroundKeyframes],
		textAlign: 'center',
	},
	cardHeader: {
		position: 'relative',
		borderTopLeftRadius: 8,
		borderTopRightRadius: 8,
		display: 'flex',
		width: '100%',
		gap: 8,
		alignItems: 'center',
		padding: '28px 28px 8px 12px',
		boxSizing: 'border-box',
	},
	cardHeaderSuggestion: {
		padding: '28px 28px 8px 12px',
	},
	cardCategory: {
		fontSize: 10,
		color: charmGray,
		alignSelf: 'flex-start',
	},
	cardCategoryMonth: {
		padding: '0 6px',
		margin: '4px 0 0',
	},
	cardCategoryQuarterly: {
		padding: '0 12px',
		margin: '0 0 8px 0',
	},
	cardBody: {
		padding: '0px 28px 4px 12px',
		width: '100%',
		boxSizing: 'border-box',
	},
	smallCardBody: {
		padding: '0px 6px 0px',
	},
	smallCardHeader: {
		padding: '26px 6px 0',
		...CssSelectors.allChildren(
			{
				textAlign: 'center',
			},
			'span'
		),
	},
	cardHeaderSmallCardSuggestion: {
		padding: '26px 6px 0',
	},
	cardHeaderTitle: {
		width: '100%',
		overflow: 'hidden',
		'-webkit-box-orient': 'vertical',
		'-webkit-line-clamp': '2',
		clamp: '2',
	},
	smallCardHeaderTitle: {
		fontSize: 10,
	},
	cardWrapper: {
		borderRadius: '8px 8px 0 0',
		border: `1px solid transparent`,
		padding: 0,
		width: '100%',
		display: 'flex',
		flexDirection: 'column',
		borderBottom: 0,
		boxSizing: 'border-box',
		background: white,
	},
	cardWrapperSmallCards: {
		padding: '0 0 6px',
		width: 'calc(100% - 16px)',
		margin: '0 auto',
	},
	cardWrapperEmail: {
		borderColor: success,
		...CssSelectors.allChildren(
			{
				background: success,
			},
			'header > span'
		),
	},
	cardWrapperSocial: {
		borderColor: spanishBlue,
		...CssSelectors.allDescendants(
			{
				background: spanishBlue,
			},
			'header > span'
		),
	},
	cardWrapperBlog: {
		borderColor: prestoPurple,
		...CssSelectors.allDescendants(
			{
				background: prestoPurple,
			},
			'header > span'
		),
	},
	cardWrapperSuggestion: {
		borderStyle: 'dashed',
	},
	aiGeneratedHeader: {
		border: '1px solid white',
		backgroundImage: 'linear-gradient(to right, #0066ff5c, #ca2c995c)',
		color: THEME.colors.icon.primary,
	},
	cardWrapperAiGenerated: {
		borderLeftColor: THEME.colors.primary.main,
		borderRightColor: THEME.colors.tertiary.main,
	},
	cardWrapperFeature: {
		background: 'linear-gradient(#fff 0 0) padding-box, linear-gradient(270deg, #32C5FF 10%, #B620E0 100%) border-box',
		animationDuration: '5s',
		animationIterationCount: 'infinite',
		animationFillMode: 'linear',
		backgroundSize: '200% 200%',
		animationName: [backgroundKeyframes],
		borderTop: 0,
	},
	eventDate: {
		position: 'absolute',
		top: 2,
		right: 12,
		color: charmGray,
		fontSize: 12,
	},
	eventFeaturedDate: {
		color: white,
	},
	footer: {
		width: '100%',
		borderTop: `1px solid transparent`,
		borderBottomLeftRadius: 8,
		borderBottomRightRadius: 8,
		marginTop: -1,
	},
	footerSmallCards: {
		maxWidth: 'calc(100% - 16px)',
		margin: '-2px auto 0',
	},
	footerInner: {
		width: '100%',
		padding: 6,
		borderRadius: '0 0 8px 8px',
		border: `1px solid transparent`,
		borderColor: destructive,
		margin: 0,
		boxSizing: 'border-box',
		fontSize: 10,
		...CssSelectors.allChildren(
			{
				display: 'flex',
				alignItems: 'center',
				justifyContent: 'space-between',
			},
			'div'
		),
	},
	footerIcon: {
		width: 15,
		height: 15,
	},
	suggestionFooterInner: {
		padding: 8,
		borderColor: aceGray,
		background,
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'space-between',
		gap: THEME.spacing.xs,
		...CssSelectors.allDescendants(
			{
				position: 'relative',
				':after': {
					content: '""',
					display: 'block',
					width: 30,
					height: 30,
					marginLeft: 4,
					position: 'absolute',
					top: '50%',
					left: -11,
					transform: 'translateY(-50%)',
				},
			},
			'.checkbox'
		),
	},
	footerInnerSmallCards: {
		padding: '6px 6px 8px',
	},
	footerInnerScheduled: {
		borderColor: brandPrimaryHover,
		background: hexToRGBA(brandPrimaryHover, 0.1),
	},
	footerInnerPending: {
		borderColor: magicOrange,
		background: hexToRGBA(magicOrange, 0.1),
	},
	footerInnerComplete: {
		borderColor: success,
		background: hexToRGBA(success, 0.1),
	},
	maxWidthContainer: {
		maxWidth: '88%',
		...CssSelectors.allChildren({
			color: hexToRGBA(titles, 0.7),
		}),
	},
	scheduleLabel: {
		fontSize: 10,
		display: 'block',
		marginLeft: 4,
		color: hexToRGBA(titles, 0.7),
	},
	scheduleLabelLink: {
		fontSize: 10,
		display: 'block',
		flexGrow: 1,
		marginLeft: 4,
		color: brandPrimary,
	},
	aiReasonAnchor: {
		display: 'inline-flex',
		alignItems: 'center',
	},
	aiReasonPopover: {
		maxWidth: 260,
		fontSize: 12,
		lineHeight: '18px',
		color: THEME.colors.text.main,
	},
	aiReasonPopoverHeader: {
		fontWeight: 600,
		marginBottom: THEME.spacing.xs,
		color: THEME.colors.text.main,
	},
	aiGeneratedLabelWrapper: {
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'space-between',
		gap: THEME.spacing.xs,
		overflow: 'hidden',
		// override cardLabelMonthly's right padding to leave room for the absolute date number
		paddingTop: THEME.spacing.xs,
		paddingRight: 36,
		paddingBottom: THEME.spacing.xs,
		paddingLeft: 12,
	},
	aiGeneratedLabelLeft: {
		display: 'inline-flex',
		alignItems: 'center',
		gap: THEME.spacing.xs,
		overflow: 'hidden',
		whiteSpace: 'nowrap',
	},
	customizationBadge: {
		display: 'inline-flex',
		alignItems: 'center',
		gap: 2,
		fontSize: THEME.typography.fontSizes.xxs,
		fontWeight: 600,
		lineHeight: 1,
		flexShrink: 0,
		whiteSpace: 'nowrap',
		borderRadius: THEME.common.borderRadius,
		paddingTop: 2,
		paddingRight: THEME.spacing.xs,
		paddingBottom: 2,
		paddingLeft: THEME.spacing.xs,
	},
	customizationBadgeCustomized: {
		color: THEME.colors.text.main,
		background: THEME.colors.success.light,
	},
	customizationBadgeNotCustomized: {
		color: THEME.colors.text.main,
		background: THEME.colors.background.dark,
	},
	customizationBadgeComplianceReviewed: {
		color: THEME.colors.text.main,
		background: THEME.colors.warning.light,
	},
});
